module.exports = __webpack_public_path__ + "img/35.10147454.png";